<template>
	<loge>
		<!-- Sidebar Menu -->
		<nav class="mt-2">
			<ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
				<li class="nav-item">
					<router-link to="/test" class="nav-link">
						<i class="fas fa-bookmark nav-icon"></i>
						<p>
							测试
						</p>
					</router-link>
				</li>
			</ul>
		</nav>
		<!-- /.sidebar-menu -->
		<!-- /.sidebar -->
	</loge>
</template>

<script>
	import loge from '@/views/components/logo.vue'

	export default {
		components: {
			loge
		},
		data() {
			return {
				name: '',
				type: ''
			}
		},
		watch: {
			name(val) {
				this.$emit('update:name', val)
			},
			type(val) {
				this.$emit('update:type', val)
			}
		},
	}
</script>
